import { Color } from '@billy/design-system'

export const placeholderColors = [
  Color.Purple200,
  Color.Yellow200,
  Color.Green200,
  Color.Lavender300,
  Color.Grey200,
] as const
